// Nomad-mon Go! — v324 FORGE EPIC (Duo + Fusion unlock ceremonies). Was v277 THE FORGE MOMENT / v299 painted forge.
// Jack: "the forge card animation is not nearly cool enough ... It needs to be massively more epic."
// One timeline, ~8-9 s since v330 (was ~6-7; forge-sfx.js ANVIL + revealTimes are the score, shared with the audio):
//   BUILD-UP  the anvil slams down; the ingredient cards are PULLED in a spiral into a molten CORE above it (the count ticks
//             up in huge gold), energy lines converge, the forge closes in to black, a rumble shakes the frame; near the end the
//             core flares in the RARITY's colour (the gacha tell), then sinks onto the anvil as the melt
//   GATE      the strikes wait for the server's yes (the melt glows on)
//   CLIMAX    the hammer: 2 (Duo) or 3 (Fusion) escalating blows (hit-stop, punch, shockwave ring, sparks, molten droplets);
//             the final blow WHITES OUT the screen (held longer by rank), a double shockwave + floor ring, a slam of the camera
//   REVEAL    the card spins out of the light (more turns by rank) white-hot, cools, faces the player; its frame + holo ignite
//             edge to edge (a light sweep); it settles; its name SLAMS in, huge Unbounded gold; Continue
// RANK (forgeRank): 0 Duo (rose-gold), 1 ember, 2 plasma, 3 prismatic Fusion — more particles, longer white, more spin, more
// rays and colour, a bigger sting. Tap after 1.5 s (first time included) skips to the final blow.
// Reduced motion: no flight, swing, shake or flash — the anvil glows, one soft pulse, the card and its name fade in.
// Low tier (or slow frames observed during the run) halves particles + resolution, drops the shimmer and the pull lines' half.
// Canvas 2D for everything drawn: every gradient is baked into a sprite at layout time, a frame is
// only drawImage blits + batched particle paths (cheap on phones). DOM for the card and the type.
import { ANVIL, ANVIL_SFX, anvilPullAt, forgeRank, revealTimes, buildAnvilIntroSfx, buildAnvilStrikeSfx } from './forge-sfx.js';
import { fusionFrameHtml, duoFrameHtml, ensureForgedFrameCss, fusionBandOf } from './forged-frame.js';
import { forgedLayersHtml, wireForgedVideos, attachForgedFx, detachForgedFx, forgedFxBurst, duoLensSweep, duoLensFollow } from './forged-card.js';

const CSS = `
#forgeCer{position:fixed;inset:0;z-index:70;overflow:hidden;touch-action:none;user-select:none;-webkit-user-select:none;
  background:#030202;
  font-family:var(--v2-ui,system-ui);color:#f6f1ea;opacity:0;transition:opacity .22s}
#forgeCer.on{opacity:1}
#forgeCer .fcStage{position:absolute;inset:0;will-change:transform}
#forgeCer canvas{position:absolute;inset:0;width:100%;height:100%}
#forgeCer .fcCard{position:absolute;left:0;top:0;aspect-ratio:1.26/1.76;border-radius:16px;opacity:0;will-change:transform,opacity;
  transform-origin:50% 50%}
#forgeCer .fcCard .art{position:absolute;inset:0;border-radius:16px;overflow:hidden;background:#111;
  box-shadow:0 40px 120px -30px rgba(0,0,0,.95),0 0 90px -10px var(--glow,rgba(255,170,80,.5))}
#forgeCer .fcCard .art img{width:100%;height:100%;object-fit:cover;display:block}
/* the card's back while it spins (shown by the frame loop whenever the card faces away: no backface-visibility, WebKit flattens it) */
#forgeCer .fcBack{position:absolute;inset:0;border-radius:16px;z-index:5;opacity:0;
  background:radial-gradient(circle at 50% 46%,#fff6d6 0%,#ffc35c 16%,#c2581a 36%,#4a1606 62%,#120604 88%);
  box-shadow:inset 0 0 0 3px rgba(255,214,140,.85),inset 0 0 40px rgba(255,150,50,.6)}
#forgeCer .fcCard.bk .fcBack{opacity:1}
#forgeCer .fcCard .hot{position:absolute;inset:-2px;border-radius:18px;z-index:6;pointer-events:none;
  background:radial-gradient(closest-side,#fffdf4 22%,rgba(255,226,160,.96) 58%,rgba(255,140,50,.9) 88%,rgba(190,60,20,.85));opacity:0}
/* the frame ignites edge to edge: revealed left -> right behind a travelling bar of light */
#forgeCer .fcCard .fxF,#forgeCer .fcCard .dxF{-webkit-clip-path:inset(-40% 140% -40% -40%);clip-path:inset(-40% 140% -40% -40%)}
#forgeCer .fcCard.ign .fxF,#forgeCer .fcCard.ign .dxF{-webkit-clip-path:inset(-40% -40% -40% -40%);clip-path:inset(-40% -40% -40% -40%);
  transition:clip-path .78s cubic-bezier(.6,0,.2,1),-webkit-clip-path .78s cubic-bezier(.6,0,.2,1)}
#forgeCer .fcCard .ignB{position:absolute;top:-8%;bottom:-8%;left:-40%;width:180%;z-index:8;pointer-events:none;opacity:0;
  background:linear-gradient(100deg,rgba(255,255,255,0) 40%,rgba(255,236,190,.55) 47%,#fff 50%,rgba(255,236,190,.55) 53%,rgba(255,255,255,0) 60%)}
#forgeCer .fcCard.ign .ignB{animation:fcIgn .78s cubic-bezier(.6,0,.2,1) forwards}
@keyframes fcIgn{0%{transform:translateX(-36%);opacity:1}82%{opacity:1}100%{transform:translateX(36%);opacity:0}}
#forgeCer .fcText{position:absolute;text-align:center;pointer-events:none}
#forgeCer .fcKick{font:800 clamp(12px,2.2vmin,22px)/1.3 "Unbounded",var(--v2-ui,system-ui),sans-serif;letter-spacing:.3em;color:var(--kc,#ffc98a);
  text-shadow:0 0 18px var(--kg),0 2px 6px rgba(0,0,0,.9);opacity:0;transform:translateY(10px);transition:opacity .45s,transform .5s cubic-bezier(.2,1,.3,1)}
#forgeCer .fcName{font:900 clamp(40px,10.5vmin,132px)/.98 "Unbounded",var(--v2-ui,system-ui),sans-serif;letter-spacing:-.015em;margin-top:.12em;
  word-break:keep-all;overflow-wrap:normal;
  background:linear-gradient(180deg,#fffbea 0%,#ffe590 36%,#f3ad3c 60%,#ffd77a 80%,#fff3c4 100%);-webkit-background-clip:text;background-clip:text;color:transparent;
  filter:drop-shadow(0 .045em 0 rgba(74,30,0,.95)) drop-shadow(0 0 .32em var(--kg,rgba(255,160,50,.55)));
  opacity:0;transform:scale(2.5);transform-origin:var(--to,50%) 60%}
#forgeCer .fcName.slam{opacity:1;transform:none;transition:transform .2s cubic-bezier(.2,1.45,.35,1),opacity .07s}
#forgeCer .fcMeta{font-size:clamp(15px,2.5vmin,26px);color:#e9dccb;margin-top:.6em;font-variant-numeric:tabular-nums;font-weight:650;
  text-shadow:0 2px 8px rgba(0,0,0,.9);opacity:0;transition:opacity .45s}
#forgeCer .fcKick.on,#forgeCer .fcMeta.on{opacity:1;transform:none}
#forgeCer .fcTap{display:inline-block;margin-top:clamp(18px,3.4vmin,36px);
  min-height:clamp(52px,8vmin,72px);padding:0 clamp(30px,5.4vmin,56px);border-radius:999px;cursor:pointer;
  background:linear-gradient(180deg,rgba(255,196,120,.2),rgba(255,140,60,.07));color:#ffecd2;
  border:1px solid rgba(255,196,124,.6);font:inherit;font-weight:700;font-size:clamp(17px,2.6vmin,24px);letter-spacing:.06em;
  opacity:0;pointer-events:none;transition:opacity .4s;box-shadow:0 0 36px -10px rgba(255,150,60,.65),inset 0 1px 0 rgba(255,236,200,.22)}
#forgeCer .fcTap.on{opacity:1;pointer-events:auto}
#forgeCer .fcHint{position:absolute;left:0;right:0;bottom:max(18px,env(safe-area-inset-bottom));text-align:center;
  font:700 clamp(10px,1.5vmin,13px)/1 "Unbounded",var(--v2-ui,system-ui),sans-serif;
  letter-spacing:.3em;color:rgba(255,214,170,.45);opacity:0;transition:opacity .6s;pointer-events:none}
#forgeCer .fcHint.on{opacity:1}
#forgeCer .fcCount{position:absolute;left:0;top:0;transform:translate(-50%,-100%);will-change:transform;font:900 clamp(30px,7.5vmin,88px)/1 "Unbounded",var(--v2-ui,system-ui),sans-serif;
  background:linear-gradient(180deg,#fffbea 0%,#ffe590 40%,#f3ad3c 75%,#ffe7a0 100%);-webkit-background-clip:text;background-clip:text;color:transparent;
  filter:drop-shadow(0 .05em 0 rgba(74,30,0,.95)) drop-shadow(0 0 .3em rgba(255,140,40,.7));
  opacity:0;transition:opacity .3s;pointer-events:none;font-variant-numeric:tabular-nums;white-space:nowrap}
#forgeCer .fcCount.on{opacity:1}
`;
let cssDone = false;
function ensureCss() {
  ensureForgedFrameCss();
  if (cssDone) return;
  cssDone = true;
  const st = document.createElement('style');
  st.id = 'forgeCerCss'; st.textContent = CSS;
  document.head.appendChild(st);
}
function loadImg(url) {
  return new Promise((res) => {
    const im = new Image();
    im.onload = () => res(im); im.onerror = () => res(null);
    setTimeout(() => res(null), 1500);          // a hung image never holds the ceremony
    im.src = url;
  });
}
function drawCover(g, im, x, y, w, h) {
  if (!im) { g.fillStyle = '#1a1a25'; g.fillRect(x, y, w, h); return; }
  const r = Math.max(w / im.width, h / im.height);
  const sw = w / r, sh = h / r;
  g.drawImage(im, (im.width - sw) / 2, (im.height - sh) / 2, sw, sh, x, y, w, h);
}
function rr(g, x, y, w, h, r) {
  g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r);
  g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath();
}
const clamp01 = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);
const easeOut3 = (x) => 1 - Math.pow(1 - clamp01(x), 3);
const easeIn3 = (x) => Math.pow(clamp01(x), 3);
const easeInOut = (x) => { x = clamp01(x); return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
const easeOutExpo = (x) => (x >= 1 ? 1 : 1 - Math.pow(2, -10 * clamp01(x)));
const rgba = (c, a) => `rgba(${c[0] | 0},${c[1] | 0},${c[2] | 0},${a < 0 ? 0 : a > 1 ? 1 : +a.toFixed(3)})`;
const SEEN_KEY = 'nomadmon-forgecer-seen-v1';

// ------------------------------------------------------------------ baked art
// Everything with a gradient is painted ONCE into an offscreen canvas; frames only blit.
function mk(w, h) { const c = document.createElement('canvas'); c.width = Math.max(1, Math.ceil(w)); c.height = Math.max(1, Math.ceil(h)); return c; }
function rng(seed) { let s = seed >>> 0; return () => { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
function radial(stops, size = 128) {
  const c = mk(size, size), x = c.getContext('2d');
  const gr = x.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
  for (const [o, col] of stops) gr.addColorStop(o, col);
  x.fillStyle = gr; x.fillRect(0, 0, size, size);
  return c;
}
let SPR = null;          // size-independent sprites, shared across ceremonies
function sprites() {
  if (SPR) return SPR;
  const smoke = mk(128, 128), sx = smoke.getContext('2d'), r = rng(7);
  for (let i = 0; i < 14; i++) {
    const a = r() * Math.PI * 2, d = r() * 26, x = 64 + Math.cos(a) * d, y = 64 + Math.sin(a) * d, rad = 22 + r() * 22;
    const gr = sx.createRadialGradient(x, y, 0, x, y, rad);
    gr.addColorStop(0, 'rgba(84,56,40,0.22)'); gr.addColorStop(1, 'rgba(84,56,40,0)');
    sx.fillStyle = gr; sx.fillRect(0, 0, 128, 128);
  }
  SPR = {
    hot: radial([[0, 'rgba(255,253,244,1)'], [0.1, 'rgba(255,236,186,0.92)'], [0.3, 'rgba(255,160,64,0.5)'], [0.62, 'rgba(210,70,14,0.14)'], [1, 'rgba(120,20,0,0)']]),
    warm: radial([[0, 'rgba(255,138,48,0.6)'], [0.35, 'rgba(226,82,20,0.26)'], [0.7, 'rgba(150,40,8,0.07)'], [1, 'rgba(90,20,0,0)']]),
    shadow: radial([[0, 'rgba(0,0,0,0.92)'], [0.55, 'rgba(0,0,0,0.55)'], [1, 'rgba(0,0,0,0)']], 96),
    smoke,
  };
  return SPR;
}
// a tapered light shaft, tinted: drawn rotated around the card on the reveal
function shaftSprite(col) {
  const c = mk(512, 48), x = c.getContext('2d');
  const gl = x.createLinearGradient(0, 0, 512, 0);
  gl.addColorStop(0, rgba(col, 0.75)); gl.addColorStop(0.25, rgba(col, 0.32)); gl.addColorStop(1, rgba(col, 0));
  x.fillStyle = gl;
  x.beginPath(); x.moveTo(0, 22); x.lineTo(512, 0); x.lineTo(512, 48); x.lineTo(0, 26); x.closePath(); x.fill();
  x.globalCompositeOperation = 'destination-in';
  const gv = x.createLinearGradient(0, 0, 0, 48);
  gv.addColorStop(0, 'rgba(0,0,0,0)'); gv.addColorStop(0.5, 'rgba(0,0,0,1)'); gv.addColorStop(1, 'rgba(0,0,0,0)');
  x.fillStyle = gv; x.fillRect(0, 0, 512, 48);
  return c;
}

// The anvil, unit A: face top at y=0, foot at y=0.56, horn tip at x=-0.64.
function anvilBody(g, A) {
  g.beginPath();
  g.moveTo(-0.3 * A, 0);
  g.lineTo(0.42 * A, 0);
  g.lineTo(0.425 * A, 0.12 * A);
  g.quadraticCurveTo(0.36 * A, 0.16 * A, 0.28 * A, 0.17 * A);
  g.quadraticCurveTo(0.15 * A, 0.22 * A, 0.15 * A, 0.34 * A);
  g.quadraticCurveTo(0.16 * A, 0.45 * A, 0.36 * A, 0.5 * A);
  g.lineTo(0.37 * A, 0.56 * A);
  g.lineTo(-0.37 * A, 0.56 * A);
  g.lineTo(-0.36 * A, 0.5 * A);
  g.quadraticCurveTo(-0.16 * A, 0.45 * A, -0.15 * A, 0.34 * A);
  g.quadraticCurveTo(-0.15 * A, 0.22 * A, -0.26 * A, 0.17 * A);
  g.lineTo(-0.3 * A, 0.15 * A);
  g.quadraticCurveTo(-0.5 * A, 0.14 * A, -0.645 * A, 0.03 * A);       // the horn
  g.quadraticCurveTo(-0.5 * A, -0.005 * A, -0.3 * A, 0);
  g.closePath();
}
function anvilTop(g, A) {        // the polished face, seen a little from above
  g.beginPath();
  g.moveTo(-0.3 * A, 0); g.lineTo(0.42 * A, 0); g.lineTo(0.405 * A, -0.04 * A); g.lineTo(-0.285 * A, -0.04 * A);
  g.quadraticCurveTo(-0.5 * A, -0.035 * A, -0.645 * A, 0.03 * A);
  g.quadraticCurveTo(-0.5 * A, -0.005 * A, -0.3 * A, 0);
  g.closePath();
}
const ANV = { x0: 0.68, y0: 0.07, w: 1.13, h: 0.65 };     // sprite box, unit A (origin = face centre)
function bakeAnvil(A, s, col) {
  const pad = 2;
  const c = mk((ANV.w * A + pad * 2) * s, (ANV.h * A + pad * 2) * s), g = c.getContext('2d');
  g.scale(s, s); g.translate(ANV.x0 * A + pad, ANV.y0 * A + pad);
  // the body: dark forged iron, lit from above, falling into shadow
  anvilBody(g, A);
  const v = g.createLinearGradient(0, 0, 0, 0.56 * A);
  v.addColorStop(0, '#3b3a40'); v.addColorStop(0.2, '#26252b'); v.addColorStop(0.3, '#121116'); v.addColorStop(0.55, '#1a191e');
  v.addColorStop(0.85, '#141317'); v.addColorStop(1, '#09090b');
  g.fillStyle = v; g.fill();
  g.save(); g.clip();
  // roundness: dark flanks, a soft sheen just right of centre
  const hz = g.createLinearGradient(-0.65 * A, 0, 0.43 * A, 0);
  hz.addColorStop(0, 'rgba(0,0,0,0.55)'); hz.addColorStop(0.3, 'rgba(0,0,0,0.12)'); hz.addColorStop(0.62, 'rgba(255,255,255,0.05)');
  hz.addColorStop(0.86, 'rgba(0,0,0,0.25)'); hz.addColorStop(1, 'rgba(0,0,0,0.7)');
  g.fillStyle = hz; g.fillRect(-0.7 * A, -0.1 * A, 1.2 * A, 0.7 * A);
  // the face plate: a lighter steel band with a hard shadow line under it
  const fp = g.createLinearGradient(0, 0, 0, 0.13 * A);
  fp.addColorStop(0, 'rgba(150,150,165,0.22)'); fp.addColorStop(0.15, 'rgba(110,110,125,0.1)'); fp.addColorStop(1, 'rgba(60,60,70,0.05)');
  g.fillStyle = fp; g.fillRect(-0.7 * A, 0, 1.2 * A, 0.13 * A);
  const ao = g.createLinearGradient(0, 0.12 * A, 0, 0.22 * A);
  ao.addColorStop(0, 'rgba(0,0,0,0.65)'); ao.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = ao; g.fillRect(-0.7 * A, 0.12 * A, 1.2 * A, 0.1 * A);
  // the feet catch a little floor light
  const ft = g.createLinearGradient(0, 0.47 * A, 0, 0.56 * A);
  ft.addColorStop(0, 'rgba(255,255,255,0)'); ft.addColorStop(0.5, 'rgba(160,150,150,0.07)'); ft.addColorStop(1, 'rgba(0,0,0,0.4)');
  g.fillStyle = ft; g.fillRect(-0.7 * A, 0.47 * A, 1.2 * A, 0.1 * A);
  // forged texture: pits and specks
  const r = rng(91), nSp = Math.min(2600, Math.round(A * 3));
  for (let i = 0; i < nSp; i++) {
    const x = -0.66 * A + r() * 1.1 * A, y = r() * 0.56 * A, sz = 0.6 + r() * 1.6;
    g.fillStyle = r() < 0.6 ? `rgba(0,0,0,${(0.12 + r() * 0.2).toFixed(2)})` : `rgba(200,200,215,${(0.03 + r() * 0.06).toFixed(2)})`;
    g.fillRect(x, y, sz, sz);
  }
  // a cool back-rim along the right-hand silhouette (separates the iron from the dark)
  const rim = g.createLinearGradient(-0.2 * A, 0, 0.45 * A, 0);
  rim.addColorStop(0, 'rgba(150,165,200,0)'); rim.addColorStop(1, 'rgba(150,165,200,0.28)');
  anvilBody(g, A); g.strokeStyle = rim; g.lineWidth = Math.max(2, A * 0.008); g.stroke();
  g.restore();
  // the top face: polished, scratched, a hardy hole at the heel
  anvilTop(g, A);
  const tg = g.createLinearGradient(0, -0.04 * A, 0, 0);
  tg.addColorStop(0, '#5b5b66'); tg.addColorStop(0.6, '#7d7e8a'); tg.addColorStop(1, '#4a4a54');
  g.fillStyle = tg; g.fill();
  g.save(); g.clip();
  const th = g.createLinearGradient(-0.64 * A, 0, 0.42 * A, 0);
  th.addColorStop(0, 'rgba(0,0,0,0.5)'); th.addColorStop(0.35, 'rgba(0,0,0,0)'); th.addColorStop(0.55, 'rgba(255,255,255,0.12)'); th.addColorStop(1, 'rgba(0,0,0,0.35)');
  g.fillStyle = th; g.fillRect(-0.7 * A, -0.05 * A, 1.2 * A, 0.1 * A);
  g.strokeStyle = 'rgba(30,30,36,0.35)'; g.lineWidth = 0.8;
  for (let i = 0; i < 14; i++) { const x = -0.25 * A + r() * 0.6 * A, y = -0.035 * A + r() * 0.03 * A; g.beginPath(); g.moveTo(x, y); g.lineTo(x + (0.03 + r() * 0.08) * A, y + (r() - 0.5) * 0.01 * A); g.stroke(); }
  g.fillStyle = '#121116'; g.fillRect(0.31 * A, -0.03 * A, 0.035 * A, 0.016 * A);
  g.restore();
  // the front edge of the face: a bevel highlight
  const eg = g.createLinearGradient(-0.3 * A, 0, 0.42 * A, 0);
  eg.addColorStop(0, 'rgba(200,200,215,0.15)'); eg.addColorStop(0.55, 'rgba(235,235,245,0.55)'); eg.addColorStop(1, 'rgba(200,200,215,0.2)');
  g.fillStyle = eg; g.fillRect(-0.3 * A, -0.002 * A, 0.72 * A, Math.max(1.2, 0.004 * A));

  // HOT: the molten glow's light on the iron (additive, alpha = heat): the face, the plate, the horn's crest
  const h = mk(c.width, c.height), hg = h.getContext('2d');
  hg.scale(s, s); hg.translate(ANV.x0 * A + pad, ANV.y0 * A + pad);
  anvilTop(hg, A);
  const rt = hg.createRadialGradient(0.04 * A, -0.02 * A, 0, 0.04 * A, -0.02 * A, 0.5 * A);
  rt.addColorStop(0, 'rgba(255,214,140,0.95)'); rt.addColorStop(0.35, rgba(col, 0.55)); rt.addColorStop(1, 'rgba(160,40,0,0)');
  hg.fillStyle = rt; hg.fill();
  hg.save(); anvilBody(hg, A); hg.clip();
  const rb = hg.createRadialGradient(0.04 * A, -0.06 * A, 0, 0.04 * A, -0.06 * A, 0.5 * A);
  rb.addColorStop(0, 'rgba(255,150,60,0.6)'); rb.addColorStop(0.4, 'rgba(220,80,20,0.22)'); rb.addColorStop(1, 'rgba(120,20,0,0)');
  hg.fillStyle = rb; hg.fillRect(-0.7 * A, -0.1 * A, 1.2 * A, 0.7 * A);
  hg.restore();
  hg.fillStyle = 'rgba(255,190,110,0.85)'; hg.fillRect(-0.22 * A, -0.002 * A, 0.5 * A, Math.max(1.2, 0.004 * A));
  return { c, h, ox: (ANV.x0 * A + pad), oy: (ANV.y0 * A + pad), w: ANV.w * A + pad * 2, hh: ANV.h * A + pad * 2 };
}
// The hammer head (+ its collar), in the hammer's frame: x along the handle (pivot at 0), head centred at x = len.
// Local +y faces the world's up at the strike angle, so the light is baked on +y; the strike face is -y.
function bakeHammer(L, s, col) {
  const { len, hl, ht, A } = L, pad = 3, cw = A * 0.07;
  const x0 = len - ht / 2 - cw - pad, y0 = -hl / 2 - pad;
  const W = ht + cw + pad * 2, H = hl + pad * 2;
  const c = mk(W * s, H * s), g = c.getContext('2d');
  g.scale(s, s); g.translate(-x0, -y0);
  const hx = len - ht / 2;
  // the collar + wedge where the handle enters
  const cg = g.createLinearGradient(0, -A * 0.04, 0, A * 0.04);
  cg.addColorStop(0, '#1b1a1f'); cg.addColorStop(0.7, '#4a4a54'); cg.addColorStop(1, '#2a2a31');
  g.fillStyle = cg; g.fillRect(hx - cw, -A * 0.034, cw + 1, A * 0.068);
  // the head: a chamfered steel block with flared striking faces
  const ch = ht * 0.12, fl = ht * 0.05;
  const head = () => {
    g.beginPath();
    g.moveTo(hx + ch - fl, -hl / 2); g.lineTo(hx + ht - ch + fl, -hl / 2); g.lineTo(hx + ht, -hl / 2 + ch); g.lineTo(hx + ht - fl * 0.6, 0);
    g.lineTo(hx + ht, hl / 2 - ch); g.lineTo(hx + ht - ch + fl, hl / 2); g.lineTo(hx + ch - fl, hl / 2); g.lineTo(hx, hl / 2 - ch);
    g.lineTo(hx + fl * 0.6, 0); g.lineTo(hx, -hl / 2 + ch); g.closePath();
  };
  head();
  const hz = g.createLinearGradient(hx, 0, hx + ht, 0);
  hz.addColorStop(0, '#141318'); hz.addColorStop(0.28, '#4d4d57'); hz.addColorStop(0.42, '#8d8e9a'); hz.addColorStop(0.58, '#3b3b44'); hz.addColorStop(1, '#0f0f13');
  g.fillStyle = hz; g.fill();
  g.save(); g.clip();
  const vz = g.createLinearGradient(0, -hl / 2, 0, hl / 2);
  vz.addColorStop(0, 'rgba(0,0,0,0.45)'); vz.addColorStop(0.5, 'rgba(0,0,0,0)'); vz.addColorStop(1, 'rgba(255,255,255,0.1)');
  g.fillStyle = vz; g.fillRect(hx - 2, -hl / 2 - 2, ht + 4, hl + 4);
  // the polished striking faces + the ridge in the middle
  for (const sy of [-1, 1]) {
    const fy = sy * (hl / 2) - (sy > 0 ? hl * 0.07 : 0);
    const fg = g.createLinearGradient(hx, 0, hx + ht, 0);
    fg.addColorStop(0, 'rgba(90,90,100,0.5)'); fg.addColorStop(0.45, 'rgba(210,210,225,0.55)'); fg.addColorStop(1, 'rgba(60,60,70,0.5)');
    g.fillStyle = fg; g.fillRect(hx - 2, fy, ht + 4, hl * 0.07);
  }
  g.fillStyle = 'rgba(0,0,0,0.35)'; g.fillRect(hx, -A * 0.004, ht, A * 0.008);
  const r = rng(53);
  for (let i = 0; i < Math.min(900, A * 1.2); i++) {
    g.fillStyle = r() < 0.6 ? `rgba(0,0,0,${(0.12 + r() * 0.2).toFixed(2)})` : `rgba(210,210,225,${(0.03 + r() * 0.07).toFixed(2)})`;
    g.fillRect(hx + r() * ht, -hl / 2 + r() * hl, 0.6 + r() * 1.4, 0.6 + r() * 1.4);
  }
  g.restore();
  // chamfer highlights (light from +y)
  g.strokeStyle = 'rgba(220,220,235,0.35)'; g.lineWidth = Math.max(1, A * 0.003);
  g.beginPath(); g.moveTo(hx + ch - fl, hl / 2); g.lineTo(hx + ht - ch + fl, hl / 2); g.stroke();
  // HOT: the striking face glowing from the ingot (additive, alpha = proximity x heat)
  const h = mk(c.width, c.height), hg = h.getContext('2d');
  hg.scale(s, s); hg.translate(-x0, -y0);
  hg.save(); head(); hg.clip();
  const rg = hg.createRadialGradient(len, -hl / 2, 0, len, -hl / 2, hl * 0.75);
  rg.addColorStop(0, 'rgba(255,220,150,0.95)'); rg.addColorStop(0.3, rgba(col, 0.5)); rg.addColorStop(1, 'rgba(150,30,0,0)');
  hg.fillStyle = rg; hg.fillRect(hx - 4, -hl / 2 - 4, ht + 8, hl + 8);
  hg.restore();
  return { c, h, x0, y0, w: W, hh: H };
}
// the handle: one cached gradient in the hammer's frame (rotation applies to it), drawn as a rect
function bakeHandle(g0, L) {
  const hw = L.A * 0.05;
  const gr = g0.createLinearGradient(0, -hw / 2, 0, hw / 2);
  gr.addColorStop(0, '#1a0f09'); gr.addColorStop(0.3, '#3d2617'); gr.addColorStop(0.62, '#6b4429'); gr.addColorStop(0.8, '#8a5c37'); gr.addColorStop(1, '#2a180e');
  return { gr, hw };
}
function bakeIngot(A, s, col) {
  const w = A * 0.46, h = A * 0.09, c = mk(w * s, h * s), g = c.getContext('2d');
  g.scale(s, s);
  rr(g, 1, 1, w - 2, h - 2, h * 0.22);
  const gr = g.createRadialGradient(w / 2, h * 0.3, 0, w / 2, h / 2, w * 0.5);
  gr.addColorStop(0, '#fffdf4'); gr.addColorStop(0.45, '#ffeab0'); gr.addColorStop(0.75, rgba(col, 1)); gr.addColorStop(1, '#c2400f');
  g.fillStyle = gr; g.fill();
  g.save(); g.clip();
  const r = rng(17);
  for (let i = 0; i < 8; i++) {             // a few faint crust flecks drifting on the melt
    const x = w * 0.15 + r() * w * 0.7, y = h * 0.2 + r() * h * 0.6, rad = 1 + r() * h * 0.12;
    g.fillStyle = `rgba(200,80,20,${(0.1 + r() * 0.12).toFixed(2)})`;
    g.beginPath(); g.ellipse(x, y, rad * 1.8, rad * 0.7, 0, 0, Math.PI * 2); g.fill();
  }
  const top = g.createLinearGradient(0, 0, 0, h);
  top.addColorStop(0, 'rgba(255,255,255,0.55)'); top.addColorStop(0.35, 'rgba(255,255,255,0)'); top.addColorStop(1, 'rgba(120,20,0,0.35)');
  g.fillStyle = top; g.fillRect(0, 0, w, h);
  g.restore();
  return { c, w, h };
}
// v299 PAINTED ART (scripts/forgecer-art.py): the forge plate, the anvil and the hammer as painted cut-outs.
// Fetched when a ceremony starts (capped with the reagent art); a miss falls back to the procedural sprites above.
const ART_URL = { room: 'assets/forge/room.webp?v1', anvil: 'assets/forge/anvil.webp?v1', hammer: 'assets/forge/hammer.webp?v1' };
let ARTIMG = null;
function loadArt() {
  if (!ARTIMG) {
    ARTIMG = { ready: Promise.all(Object.entries(ART_URL).map(([k, u]) => new Promise((res) => {
      const im = new Image(); im.decoding = 'async';
      im.onload = () => { ARTIMG[k] = im; res(); }; im.onerror = () => { ARTIMG = null; res(); };
      im.src = u;
    }))) };
  }
  return ARTIMG.ready;
}
// the anvil cut-out spans the horn tip (x = -0.645A) to the heel (0.425A); its top face is at the image top
const ANV_IMG = { x: -0.645, w: 1.07, top: -0.012 };
function bakeAnvilImg(im, A, s, col) {
  const w = ANV_IMG.w * A, h = w * im.height / im.width;
  const c = mk(w * s, h * s), g = c.getContext('2d');
  g.scale(s, s); g.drawImage(im, 0, 0, w, h);
  // HOT: the iron's own colour multiplied by the molten light from the face (added at alpha = heat)
  const hc = mk(c.width, c.height), hg = hc.getContext('2d');
  hg.scale(s, s); hg.drawImage(im, 0, 0, w, h);
  hg.globalCompositeOperation = 'multiply';
  const cx = (0.045 - ANV_IMG.x) * A;
  const rg = hg.createRadialGradient(cx, 0, 0, cx, 0, A * 0.62);
  rg.addColorStop(0, 'rgb(255,236,190)'); rg.addColorStop(0.3, rgba(col, 1)); rg.addColorStop(0.7, 'rgb(90,24,4)'); rg.addColorStop(1, 'rgb(0,0,0)');
  hg.fillStyle = rg; hg.fillRect(0, 0, w, h);
  hg.globalCompositeOperation = 'destination-in'; hg.drawImage(im, 0, 0, w, h);
  hg.globalCompositeOperation = 'lighter';     // the face's front edge burns brighter
  const eg = hg.createLinearGradient(cx - A * 0.4, 0, cx + A * 0.4, 0);
  eg.addColorStop(0, 'rgba(255,140,50,0)'); eg.addColorStop(0.5, 'rgba(255,190,110,0.7)'); eg.addColorStop(1, 'rgba(255,140,50,0)');
  hg.fillStyle = eg; hg.fillRect(cx - A * 0.4, h * 0.02, A * 0.8, Math.max(1.5, A * 0.006));
  return { c, h: hc, ox: -ANV_IMG.x * A, oy: -ANV_IMG.top * A, w, hh: h, foot: ANV_IMG.top * A + h };
}
// the hammer cut-out: head on the left (its centre at 6.3% of the width), the handle running right; drawn in the
// frame rotated by (th - PI) so the handle points at the pivot. The far end of the handle fades into the dark.
function bakeHammerImg(im, L, s, col) {
  const hh = L.hl * 1.02, w = hh * im.width / im.height;
  const c = mk(w * s, hh * s), g = c.getContext('2d');
  g.scale(s, s); g.drawImage(im, 0, 0, w, hh);
  g.globalCompositeOperation = 'destination-out';
  const fg = g.createLinearGradient(w * 0.62, 0, w, 0);
  fg.addColorStop(0, 'rgba(0,0,0,0)'); fg.addColorStop(1, 'rgba(0,0,0,1)');
  g.fillStyle = fg; g.fillRect(w * 0.62, 0, w * 0.38, hh);
  const hc = mk(c.width, c.height), hg = hc.getContext('2d');
  hg.scale(s, s); hg.drawImage(c, 0, 0, w, hh);
  hg.globalCompositeOperation = 'multiply';
  const hx = w * 0.063;
  const rg = hg.createRadialGradient(hx, hh, 0, hx, hh, hh * 0.8);
  rg.addColorStop(0, 'rgb(255,236,190)'); rg.addColorStop(0.35, rgba(col, 1)); rg.addColorStop(1, 'rgb(0,0,0)');
  hg.fillStyle = rg; hg.fillRect(0, 0, w, hh);
  hg.globalCompositeOperation = 'destination-in'; hg.drawImage(c, 0, 0, w, hh);
  return { img: true, c, h: hc, x0: -L.len - hx, y0: -hh / 2, w, hh };
}
// the heat on a card lying on the anvil: white-hot at its foot, orange, gone at the top
function bakeCardHeat() {
  const c = mk(4, 128), g = c.getContext('2d');
  const gr = g.createLinearGradient(0, 128, 0, 0);
  gr.addColorStop(0, 'rgba(255,248,220,1)'); gr.addColorStop(0.35, 'rgba(255,170,70,0.85)'); gr.addColorStop(0.75, 'rgba(220,70,20,0.4)'); gr.addColorStop(1, 'rgba(160,30,0,0)');
  g.fillStyle = gr; g.fillRect(0, 0, 4, 128);
  return c;
}
// the forge itself: stone wall + floor in the dark, lit by the hearth around the anvil (static; heat adds light on top)
function bakeRoom(W, H, L, bs, col, img) {
  const { ax, ay, A } = L, fy = ay + 0.56 * A;
  const pad = 40;
  const c = mk((W + pad * 2) * bs, (H + pad * 2) * bs), g = c.getContext('2d');
  g.scale(bs, bs); g.translate(pad, pad);
  g.fillStyle = '#040202'; g.fillRect(-pad, -pad, W + pad * 2, H + pad * 2);
  if (img) {
    // the painted forge, cover-fit, pushed down into the dark so the molten light owns the frame
    const sc = Math.max((W + pad * 2) / img.width, (H + pad * 2) / img.height), iw = img.width * sc, ih = img.height * sc;
    g.drawImage(img, (W - iw) / 2, (H - ih) / 2 + (H + pad * 2 - ih) * 0, iw, ih);
    g.fillStyle = 'rgba(3,2,2,0.38)'; g.fillRect(-pad, -pad, W + pad * 2, H + pad * 2);
  } else {
  // the wall: rough blocks, staggered
  const r = rng(3), bh = Math.max(26, A * 0.13), bw = bh * 2.1;
  for (let row = 0, y = fy - bh; y > -pad - bh; row++, y -= bh) {
    for (let x = -pad - (row % 2) * bw / 2; x < W + pad; x += bw) {
      const k = r();
      g.fillStyle = `rgb(${(30 + k * 16) | 0},${(21 + k * 10) | 0},${(17 + k * 7) | 0})`;
      g.fillRect(x + 2, y + 2, bw - 4, bh - 4);
      g.fillStyle = 'rgba(255,200,160,0.04)'; g.fillRect(x + 2, y + 2, bw - 4, 2);
    }
  }
  // the floor: worn flagstones receding
  const fl = g.createLinearGradient(0, fy, 0, H + pad);
  fl.addColorStop(0, '#1d1310'); fl.addColorStop(1, '#070404');
  g.fillStyle = fl; g.fillRect(-pad, fy, W + pad * 2, H + pad - fy);
  g.strokeStyle = 'rgba(0,0,0,0.5)'; g.lineWidth = 2;
  for (let k = 1; k < 6; k++) { const y = fy + (H + pad - fy) * Math.pow(k / 6, 1.6); g.beginPath(); g.moveTo(-pad, y); g.lineTo(W + pad, y); g.stroke(); }
  for (let k = -8; k <= 8; k++) { g.beginPath(); g.moveTo(ax + k * A * 0.22, fy); g.lineTo(ax + k * A * 0.6, H + pad); g.stroke(); }
  }
  // darkness closes in away from the hearth
  const dk = g.createRadialGradient(ax, ay - A * 0.1, A * 0.15, ax, ay - A * 0.1, Math.max(A * 1.5, Math.hypot(W, H) * 0.55));
  dk.addColorStop(0, 'rgba(4,2,2,0)'); dk.addColorStop(0.55, `rgba(4,2,2,${img ? 0.45 : 0.72})`); dk.addColorStop(1, `rgba(3,2,2,${img ? 0.9 : 0.97})`);
  g.fillStyle = dk; g.fillRect(-pad, -pad, W + pad * 2, H + pad * 2);
  // the hearth's light on the wall and a pool of it on the floor
  g.globalCompositeOperation = 'lighter';
  const hw = g.createRadialGradient(ax, ay, 0, ax, ay, A * 1.25);
  hw.addColorStop(0, rgba(col, 0.16)); hw.addColorStop(0.5, 'rgba(200,70,20,0.06)'); hw.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = hw; g.fillRect(-pad, -pad, W + pad * 2, H + pad * 2);
  g.save(); g.translate(ax, fy); g.scale(1, 0.2);
  const pl = g.createRadialGradient(0, 0, 0, 0, 0, A * 1.3);
  pl.addColorStop(0, 'rgba(255,120,40,0.22)'); pl.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = pl; g.fillRect(-A * 1.4, -A * 1.4, A * 2.8, A * 2.8);
  g.restore();
  g.globalCompositeOperation = 'source-over';
  // a cinematic vignette
  const vg = g.createRadialGradient(W / 2, H * 0.55, Math.min(W, H) * 0.3, W / 2, H * 0.55, Math.hypot(W, H) * 0.62);
  vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(0,0,0,0.85)');
  g.fillStyle = vg; g.fillRect(-pad, -pad, W + pad * 2, H + pad * 2);
  return { c, pad };
}

// PALETTES: col = the molten light of the forge (amber -> gold -> white-gold by band; a Duo's is rose-gold).
function paletteOf(kind, band) {
  if (kind === 'duo') return { col: [255, 160, 140] };
  return [{ col: [255, 156, 60] }, { col: [255, 182, 90] }, { col: [255, 214, 150] }][band];
}
// RANKS: the reveal's colours (rays, the core's tell, the ignite + confetti sparks), how many rays, the label, the spin.
const RANKS = [
  { label: 'DUO FORGED', rc: [[255, 176, 150], [150, 226, 255]], rays: 9, spin: 180 },
  { label: 'EMBER FUSION', rc: [[255, 196, 92], [255, 238, 176]], rays: 11, spin: 360 },
  { label: 'PLASMA FUSION', rc: [[176, 124, 255], [92, 232, 255], [255, 220, 150]], rays: 14, spin: 540 },
  { label: 'PRISMATIC FUSION', rc: [[255, 92, 200], [95, 255, 225], [255, 226, 92], [130, 150, 255], [255, 150, 70]], rays: 18, spin: 720 },
];
// a soft ring (the shockwave): bright just inside its edge
function ringSprite() {
  return radial([[0, 'rgba(255,255,255,0)'], [0.62, 'rgba(255,255,255,0)'], [0.84, 'rgba(255,250,236,0.5)'], [0.93, 'rgba(255,255,255,1)'], [1, 'rgba(255,255,255,0)']], 256);
}
// the forge closing in: clear in the middle, black at the edges
function vignetteSprite() {
  return radial([[0, 'rgba(0,0,0,0)'], [0.22, 'rgba(0,0,0,0)'], [0.5, 'rgba(1,0,0,0.55)'], [0.78, 'rgba(1,0,0,0.92)'], [1, 'rgba(1,0,0,1)']], 256);
}

/**
 * kind 'fusion' | 'duo'. reagents: [{url, rect?}] (rect = where the card sat on the sheet).
 * pending: optional Promise<{ok, level?}> — the strikes wait for it; a failure aborts (resolves false).
 * vo(name): optional voice line after the reveal. Resolves true when the player leaves the reveal.
 * onCovered(): optional, once the ceremony has faded fully opaque (the screen under it may be torn down then).
 * onExit(ok): optional, as the player leaves, BEFORE the fade-out: repaint the screen underneath here, while it is covered.
 */
export function runForgeCeremony({ kind, reagents = [], card, artUrl, level = 1, power = 0, playSynth = null, sfxBuffer = null, loadSfx = null,
  haptics = null, srcs = null, pending = null, vo = null, onCovered = null, onExit = null }) {
  ensureCss();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tier = card.tier || 1;
  const band = kind === 'fusion' ? fusionBandOf(tier) : 1;
  const rank = forgeRank(kind, kind === 'fusion' ? band : 0);
  const RK = RANKS[rank], RT = revealTimes(rank);
  const P = paletteOf(kind, band);
  const col = P.col;
  const rc0 = RK.rc[0];
  const root = document.createElement('div');
  root.id = 'forgeCer';
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-label', kind === 'fusion' ? 'Fusion forged' : 'Duo forged');
  root.innerHTML = `<div class="fcStage"><canvas></canvas>
    <div class="fcCard" style="--glow:${rgba(rc0, 0.6)}"><span class="art"><img alt="" src="${artUrl}">${forgedLayersHtml(card, { frame: false, size: 'full' })}</span>
      ${kind === 'fusion' ? fusionFrameHtml(tier) : duoFrameHtml()}<span class="fcBack"></span><span class="hot"></span><span class="ignB"></span></div></div>
    <div class="fcText" style="--kc:${rgba([Math.min(255, rc0[0] * 0.45 + 150), Math.min(255, rc0[1] * 0.45 + 150), Math.min(255, rc0[2] * 0.45 + 140)], 1)};--kg:${rgba(rc0, 0.5)}"><div class="fcKick">${kind === 'fusion' ? `${RK.label} · TIER ${tier}` : RK.label}</div>
      <div class="fcName"></div><div class="fcMeta"></div><button class="fcTap" type="button">Continue</button></div>
    <div class="fcHint">TAP TO SKIP</div><div class="fcCount"></div>`;
  const nameEl = root.querySelector('.fcName');
  nameEl.textContent = card.name;
  const kickEl = root.querySelector('.fcKick');
  const metaEl = root.querySelector('.fcMeta');
  const setMeta = (lv) => { metaEl.textContent = `★${card.stars} · PWR ${power} · starts at LV ${lv}`; };
  setMeta(level);
  document.body.appendChild(root);
  requestAnimationFrame(() => {
    root.classList.add('on');
    // v330 FLICKER: the sheet under the ceremony used to be torn down on a fixed 260 ms timer, which a slow bake
    // (Android) put mid-fade: the screen under the sheet showed through the half-faded ceremony. Now: once opaque.
    if (onCovered) {
      let fired0 = false;
      const cov = () => { if (fired0) return; fired0 = true; try { onCovered(); } catch (err) { console.warn('[forge] onCovered', err); } };
      root.addEventListener('transitionend', (e) => { if (e.target === root && e.propertyName === 'opacity') cov(); });
      setTimeout(cov, 400);
    }
  });
  const cv = root.querySelector('canvas');
  const g = cv.getContext('2d');
  const stageEl = root.querySelector('.fcStage');
  const cardEl = root.querySelector('.fcCard');
  const hotEl = cardEl.querySelector('.hot');
  const textEl = root.querySelector('.fcText');
  const tapEl = root.querySelector('.fcTap');
  const hintEl = root.querySelector('.fcHint');
  const countEl = root.querySelector('.fcCount');
  const state = { phase: 'intro', t: 0, kind, rank, done: false, lite: false, strikes: 0 };
  window.__nmForgeCer = state;
  let seen = false;
  try { seen = localStorage.getItem(SEEN_KEY) === '1'; } catch { /* private */ }
  const SP = sprites();
  const shafts = RK.rc.map((c) => shaftSprite(c));
  const tints = RK.rc.map((c) => radial([[0, rgba([Math.min(255, c[0] + 60), Math.min(255, c[1] + 60), Math.min(255, c[2] + 60)], 1)], [0.25, rgba(c, 0.75)], [0.6, rgba(c, 0.18)], [1, rgba(c, 0)]]));
  const RING = ringSprite(), VIG = vignetteSprite();
  const cardHeat = bakeCardHeat();
  const shimmerCv = mk(8, 8), shimmerG = shimmerCv.getContext('2d');

  // ---- quality: low tier starts lite; slow frames observed during the run demote (never persisted)
  let lite = !!(/Android/i.test(navigator.userAgent) && (navigator.deviceMemory || 8) <= 4) || (navigator.hardwareConcurrency || 8) <= 3;
  let W = 0, H = 0, dpr = 1, L = null, ART = null;
  // the name fills its column: as big as the type allows, never wider than the column (words never break)
  const fitName = () => {
    nameEl.style.fontSize = '';
    let fs = parseFloat(getComputedStyle(nameEl).fontSize) || 48;
    for (let k = 0; k < 40 && nameEl.scrollWidth > nameEl.clientWidth + 1 && fs > 18; k++) { fs -= 3; nameEl.style.fontSize = `${fs}px`; }
  };
  const layout = () => {
    W = innerWidth; H = innerHeight;
    const maxPx = lite ? 1.1e6 : 2.6e6;
    dpr = Math.max(0.6, Math.min(lite ? 1.25 : 2, devicePixelRatio || 1, Math.sqrt(maxPx / Math.max(1, W * H))));
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    const portrait = H > W * 0.8;          // near-square (Fold) stacks too: the side column would be too narrow for the name
    const A = portrait ? Math.min(W * 0.8, H * 0.42, 820) : Math.min(W * 0.5, H * 0.56, 900);
    const ax = portrait ? W * 0.53 : W / 2, ay = portrait ? H * 0.62 : H * 0.66;
    // hammer: a giant swung from off-screen right; the head lands on the face
    const hl = A * 0.44, ht = A * 0.22, len = A * 0.95;
    const C = { x: ax + A * 0.04, y: ay - hl * 0.48 };
    const phi = -0.36;
    const piv = { x: C.x + len * Math.cos(phi), y: C.y + len * Math.sin(phi) };
    const thI = phi + Math.PI;
    // the core: above the anvil's face, where the cards are pulled
    const core = { x: ax + A * 0.04, y: ay - A * (portrait ? 0.58 : 0.62) };
    // the card at rest (after the giant reveal): portrait = centred above the text, landscape = left of it
    let rh, rcx, rcy, tx, ty, tw;
    if (portrait) {
      rh = Math.min(H * 0.52, (W - 64) * 1.397);
      rcx = W / 2; rcy = Math.max(H * 0.05, 24) + rh / 2;
      tx = 16; tw = W - 32; ty = rcy + rh / 2 + Math.min(30, H * 0.032);
    } else {
      rh = Math.min(H * 0.78, (W * 0.46) * 1.397);
      const rw = rh / 1.397;
      rcx = Math.max(rw / 2 + 40, W * 0.3); rcy = H * 0.48;
      tx = rcx + rw / 2 + Math.max(28, W * 0.045); tw = Math.max(200, W - tx - 40); ty = null;
    }
    const rw = rh / 1.397;
    // the giant reveal fills the screen but keeps its frame's glow on it
    const gs = portrait ? Math.min((H * 0.8) / rh, (W * 0.86) / rw) : Math.min((H * 0.86) / rh, (W * 0.8) / rw);
    // the hammer's wind-up keeps its head on screen (short landscape: a lower ceiling)
    let maxRaise = 1.6;
    while (maxRaise > 0.7 && piv.y + len * Math.sin(thI + maxRaise) < hl * 0.55) maxRaise -= 0.05;
    state.idle = false;          // a resize clears the canvas: draw the settled frame again
    L = { portrait, A, ax, ay, fy: ay + 0.56 * A, hl, ht, len, C, piv, thI, maxRaise, core, rh, rw, rcx, rcy, tx, ty, tw, gs };
    // bake the art for this size (sprites at the canvas's own density; the room is soft, so half of it)
    const sc = Math.min(dpr, 2);
    const im = ARTIMG && ARTIMG.room && ARTIMG.anvil && ARTIMG.hammer ? ARTIMG : null;
    ART = { room: bakeRoom(W, H, L, Math.min(1, dpr) * (lite ? 0.5 : 0.75), col, im && im.room),
      anvil: im ? bakeAnvilImg(im.anvil, A, sc, col) : bakeAnvil(A, sc, col), hammer: im ? bakeHammerImg(im.hammer, L, sc, col) : bakeHammer(L, sc, col),
      handle: bakeHandle(g, L), ingot: bakeIngot(A, sc, col) };
    if (ART.anvil.foot) L.fy = ay + ART.anvil.foot;
    stageEl.style.transformOrigin = `${ax.toFixed(0)}px ${(ay - A * 0.2).toFixed(0)}px`;
    cardEl.style.width = `${rw}px`; cardEl.style.height = `${rh}px`;
    textEl.style.left = `${tx}px`; textEl.style.width = `${tw}px`;
    if (portrait) { textEl.style.top = `${ty}px`; textEl.style.textAlign = 'center'; textEl.style.transform = ''; textEl.style.setProperty('--to', '50%'); }
    else { textEl.style.top = `${rcy}px`; textEl.style.textAlign = 'left'; textEl.style.transform = 'translateY(-50%)'; textEl.style.setProperty('--to', '0%'); }
    fitName();
  };
  layout();
  addEventListener('resize', layout);

  // ---- particles (one pool): 0 sparks (streaks that arc + bounce), 1 embers (float up), 2 molten droplets, 3 smoke/dust
  const parts = [];
  const cap = () => (lite ? 420 : 1200);
  const add = (q) => { if (parts.length < cap()) parts.push(q); };
  const pm = () => (lite ? 0.5 : 1);
  // sparks: `c` = a fixed colour (index into SPK) for the rarity confetti, else they cool white -> gold -> orange -> red
  const sparks = (x, y, n, sp, spread = Math.PI, dir = -Math.PI / 2, c = -1, s = 0) => {
    for (let i = 0; i < n * pm(); i++) {
      const a = dir + (Math.random() - 0.5) * spread * 2, v = sp * (0.3 + Math.random() * 0.9);
      const life = 0.55 + Math.random() * 1.0;
      add({ k: 0, x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life, max: life, b: 0, s: s || (Math.random() < 0.25 ? 2.4 : 1.4), c });
    }
  };
  const embers = (x, y, n, w) => {
    if (reduced) return;
    for (let i = 0; i < n * pm(); i++) {
      const life = 1 + Math.random() * 1.6;
      add({ k: 1, x: x + (Math.random() - 0.5) * w, y, vx: (Math.random() - 0.5) * 40, vy: -40 - Math.random() * 120, life, max: life,
        s: 0.8 + Math.random() * 1.8, ph: Math.random() * 6 });
    }
  };
  const droplets = (x, y, n, sp) => {
    for (let i = 0; i < n * pm(); i++) {
      const a = -Math.PI / 2 + (Math.random() - 0.5) * 2.4, v = sp * (0.35 + Math.random() * 0.75);
      const life = 1.3 + Math.random() * 0.9;
      add({ k: 2, x: x + (Math.random() - 0.5) * L.A * 0.1, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life, max: life, b: 0, s: L.A * (0.004 + Math.random() * 0.006) });
    }
  };
  const smoke = (x, y, n, { vx = 0, spread = 0.2, vy = -30, size = 0.18, a = 0.6 } = {}) => {
    if (reduced) return;
    for (let i = 0; i < Math.ceil(n * pm()); i++) {
      const life = 1.6 + Math.random() * 1.4;
      add({ k: 3, x: x + (Math.random() - 0.5) * L.A * spread, y, vx: vx * (0.5 + Math.random()) * (Math.random() < 0.5 ? -1 : 1), vy: vy * (0.6 + Math.random() * 0.8),
        life, max: life, s: L.A * size * (0.7 + Math.random() * 0.6), a, rot: Math.random() * 6 });
    }
  };
  // shockwave rings: {x, y, r1 (final radius), age, dur, a, flat (y squash), tint (sprite index or -1 = white)}
  const rings = [];
  const ring = (x, y, r1, dur, a = 1, flat = 1, tint = -1) => { if (!reduced) rings.push({ x, y, r1, age: 0, dur, a, flat, tint }); };
  let flash = 0, bloom = 0, streak = 0, shakeA = 0, shakeT = 0, punch = 0, coreKick = 0, whiteAt = -1;

  // ---- the timeline: G (gate) moves when the server is slow; `skipTo` = first blow still to play
  const S = ANVIL.strikes[kind], last = S.length - 1;
  // Fusions spend 40-190 cards: the pull shows a representative stream (<= 16 sprites) under a count
  const nAll = Math.max(1, reagents.length);
  const MAXP = 16;
  const pick = reagents.length <= MAXP ? reagents : Array.from({ length: MAXP }, (_, j) => reagents[Math.round((j * (reagents.length - 1)) / (MAXP - 1))]);
  const n = Math.max(1, pick.length);
  let G = null, skipTo = 0, resolved = !pending, failed = false, rush = false, introCue = null, strikeCue = null;
  const F = () => (G === null ? Infinity : G + S[last]);          // the final blow
  const B = () => F() + ANVIL.burst;                              // the light bursts out
  const strikeAt = (i) => (G === null ? Infinity : G + S[i]);
  const stopOf = (i) => (i === last ? ANVIL.stop[2] + 0.02 * rank : ANVIL.stop[Math.min(i, 1)]);
  const fired = new Set();
  let consumed = 0;

  return new Promise(async (resolve) => {
    // the recorded forge takes decode alongside the reagent art (capped: a slow decode drops its layers, it never holds the ceremony)
    const sfxReady = loadSfx ? Promise.race([Promise.resolve().then(() => loadSfx(ANVIL_SFX)).catch(() => {}), new Promise((r) => setTimeout(r, 1200))]) : null;
    const artReady = reduced ? null : Promise.race([loadArt(), new Promise((r) => setTimeout(r, 1500))]);
    const [imgs] = await Promise.all([Promise.all(pick.map(r => loadImg(r.url))), sfxReady, artReady]);
    if (ARTIMG && ARTIMG.anvil && ARTIMG.hammer && ARTIMG.room && !ART.anvil.foot) layout();   // the painted art arrived: re-bake with it
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { if (!state.done) fitName(); }).catch(() => {});
    const buf = sfxBuffer || (() => null);
    if (playSynth && !reduced) introCue = playSynth(`forge-anvil-${kind}`, (ctx, out, t0) => buildAnvilIntroSfx(ctx, out, t0, { kind, rank, n, buf }), { gain: 0.71 });   // audiopolish: -3 dB (-10 -> -13 LUFS)
    if (pending) {
      Promise.resolve(pending).then((r) => {
        if (!r || r.ok === false) { failed = true; return; }
        if (r.level) setMeta(r.level);
        resolved = true;
      }, () => { failed = true; });
    }
    const t0 = performance.now();
    let prevNow = t0, slow = 0, frames = 0, qaT = 0;
    // reagent start positions: their spot on the sheet, else a row across the bottom
    const cw0 = Math.min(84, W / (n + 1));
    const start = pick.map((r, i) => (r.rect && r.rect.width > 4
      ? { x: r.rect.left + r.rect.width / 2, y: r.rect.top + r.rect.height / 2, w: r.rect.width }
      : { x: W / 2 + (i - (n - 1) / 2) * cw0 * 1.05, y: H * 0.86, w: cw0 }));

    const finish = (ok = true) => {
      if (state.done) return;
      state.done = true; state.phase = 'done';
      if (ok && !failed) { try { localStorage.setItem(SEEN_KEY, '1'); } catch { /* private */ } }
      if (state.t < B()) for (const c of [introCue, strikeCue]) if (c && c.gain) { try { c.gain.setTargetAtTime(0, c.context.currentTime, 0.08); } catch { /* gone */ } }
      if (state.sweep && state.sweep.stop) state.sweep.stop(false);
      detachForgedFx(cardEl);
      removeEventListener('resize', layout);
      // v330 FLICKER: the screen underneath is repainted HERE, while the ceremony still covers it (it used to be
      // repainted after the fade: the old screen showed through, then its card was re-mounted and blinked);
      // hit-tests see through the leaving ceremony (the shared FX layer's cover check would otherwise hide + re-show)
      root.style.pointerEvents = 'none';
      if (onExit) { try { onExit(ok && !failed); } catch (err) { console.warn('[forge] onExit', err); } }
      // two frames for the new images to decode under the cover, then fade
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('on')));
      setTimeout(() => { root.remove(); resolve(ok && !failed); }, 280);
    };
    tapEl.addEventListener('click', (e) => { e.stopPropagation(); finish(true); });
    // TAP TO SKIP (after 1.5 s, first forge included; at once for a returning forger): straight to the final blow
    root.addEventListener('pointerdown', (e) => {
      if (e.target === tapEl) return;
      if (state.phase === 'ready') { finish(true); return; }
      if (seen || state.t >= 1.5) doRush();
    });
    // Back (nav.js level 'forgeCer', forgeui.js) also jumps to the final blow
    const doRush = () => {
      if (reduced || rush || state.done || state.t >= F() - 0.5) return;
      rush = true;
      hintEl.classList.remove('on');
      if (introCue && introCue.gain) { try { introCue.gain.setTargetAtTime(0, introCue.context.currentTime, 0.05); } catch { /* gone */ } }
      if (strikeCue && strikeCue.gain) { try { strikeCue.gain.setTargetAtTime(0, strikeCue.context.currentTime, 0.04); } catch { /* gone */ } strikeCue = null; }
      const jump = Math.max(0, ANVIL.gate - state.t);
      tShift += jump; state.t += jump;
      if (G !== null) openGate(true);
    };
    state.rush = doRush;
    let tShift = 0;
    const openGate = (jump) => {
      const t = state.t;
      if (jump) { skipTo = last; G = t + 0.62 - S[last]; for (let i = 0; i < last; i++) fired.add(`s${i}`); }
      else G = Math.max(ANVIL.gate, t + 0.05);
      if (reduced) { skipTo = last; G = t + 0.3 - S[last]; for (let i = 0; i < last; i++) fired.add(`s${i}`); }
      state.phase = 'strike';
      if (playSynth) {
        const off = G - t;
        strikeCue = playSynth(`forge-strike-${kind}`, (ctx, out, a0) => buildAnvilStrikeSfx(ctx, out, a0 + off, { kind, rank, buf, from: skipTo }), { gain: 0.63 });   // audiopolish: -4 dB
      }
    };
    if (!reduced) setTimeout(() => { if (!rush && !state.done && state.t < ANVIL.gate) hintEl.classList.add('on'); }, seen ? 500 : 1500);

    // ------------------------------------------------------------ drawing
    const blit = (c, x, y, w, h) => g.drawImage(c, x, y, w, h);
    const glow = (spr, x, y, r, a) => { if (a > 0.004) { g.globalAlpha = a > 1 ? 1 : a; g.drawImage(spr, x - r, y - r, r * 2, r * 2); } };
    // the rank's tints in turn, cross-faded (never a hard colour cut): ph = position in the cycle, 1 per colour
    const tintGlow = (ph, x, y, r, a) => {
      const k = Math.floor(ph), fr = ph - k, n0 = tints.length;
      glow(tints[k % n0], x, y, r, a * (1 - fr));
      if (n0 > 1) glow(tints[(k + 1) % n0], x, y, r, a * fr);
    };
    const drawAnvil = (y, a, heat) => {
      if (a <= 0) return;
      const { ax } = L, an = ART.anvil;
      g.globalAlpha = a;
      blit(an.c, ax - an.ox, y - an.oy, an.w, an.hh);
      if (heat > 0.01) {
        g.globalCompositeOperation = 'lighter';
        g.globalAlpha = a * Math.min(1, heat);
        blit(an.h, ax - an.ox, y - an.oy, an.w, an.hh);
        g.globalCompositeOperation = 'source-over';
      }
      g.globalAlpha = 1;
    };
    const drawHammer = (th, a, smear, heat) => {
      if (a <= 0) return;
      const { piv, len, A } = L, hm = ART.hammer, hd = ART.handle;
      const one = (ang, al, hot) => {
        g.save();
        g.translate(piv.x, piv.y); g.rotate(hm.img ? ang - Math.PI : ang);
        g.globalAlpha = al;
        if (!hm.img) { g.fillStyle = hd.gr; g.fillRect(-Math.max(W, H) * 1.5, -hd.hw / 2, Math.max(W, H) * 1.5 + len - L.ht / 2 - A * 0.06, hd.hw); }    // the handle runs off-screen
        g.drawImage(hm.c, hm.x0, hm.y0, hm.w, hm.hh);
        if (hot > 0.01) { g.globalCompositeOperation = 'lighter'; g.globalAlpha = al * Math.min(1, hot); g.drawImage(hm.h, hm.x0, hm.y0, hm.w, hm.hh); }
        g.restore();
      };
      if (smear && !lite) for (let k = 3; k >= 1; k--) one(th + smear * k * 0.2, a * 0.14 * (4 - k) / 3, 0);
      one(th, a, heat);
    };
    // hammer angle at t: hover before the first windup, then windup -> swing -> hit-stop -> rebound per blow
    const hammerPose = (t) => {
      const thI = L.thI;
      const raise = (i) => Math.min(L.maxRaise, i === last ? 1.5 : 1.05 + 0.18 * i) * (i === last ? 1 : Math.min(1, L.maxRaise / 1.5));
      if (G === null) return { th: thI + raise(0) + 0.04 * Math.sin(t * 1.6), smear: 0 };
      for (let i = skipTo; i <= last; i++) {
        const h = strikeAt(i), stop = stopOf(i);
        const up = i === last ? 0.5 : 0.3;      // v330 windups x1.25 (were .4 / .24); the swing stays .13
        const prevRest = i === skipTo ? thI + raise(i) * 0.75 : thI + 0.28;
        if (t < h - 0.13 - up) return { th: prevRest, smear: 0 };
        if (t < h - 0.13) { const p = easeOut3((t - (h - 0.13 - up)) / up); return { th: prevRest + (thI + raise(i) - prevRest) * p, smear: 0 }; }
        if (t < h) { const p = easeIn3((t - (h - 0.13)) / 0.13); return { th: thI + raise(i) * (1 - p), smear: raise(i) * 0.25 * (1 - p * 0.3) }; }
        if (t < h + stop) return { th: thI, smear: 0 };
        if (i === last) return { th: thI - 0.02, smear: 0 };
        if (t < h + stop + 0.12) return { th: thI + 0.28 * easeOut3((t - h - stop) / 0.12), smear: 0 };
      }
      return { th: thI, smear: 0 };
    };
    const inStop = (t) => {
      for (let i = skipTo; i <= last; i++) { const h = strikeAt(i); if (t >= h && t < h + stopOf(i)) return true; }
      return false;
    };
    const drawIngot = (t, heat, squash) => {
      if (heat <= 0) return;
      const { ax, ay, A } = L, ing = ART.ingot;
      const w = A * (0.2 + 0.22 * heat) * squash, h = A * 0.06 * Math.min(1, heat * 1.4) / Math.sqrt(squash);
      const x = ax + A * 0.04, y = ay - h * 0.5;
      const pulse = 0.88 + 0.08 * Math.sin(t * 9) + 0.04 * Math.sin(t * 23);
      g.globalCompositeOperation = 'lighter';
      glow(SP.warm, x, y, w * 1.5, 0.75 * heat * pulse);
      g.globalCompositeOperation = 'source-over';
      g.globalAlpha = Math.min(1, heat * 1.6);
      blit(ing.c, x - w / 2, y - h / 2, w, h);
      g.globalCompositeOperation = 'lighter';
      glow(SP.hot, x, y, w * 0.62, 0.35 * heat * pulse);
      g.globalCompositeOperation = 'source-over';
      g.globalAlpha = 1;
    };
    // where the core is at t: above the anvil through the pull, then it sinks onto the face (the melt)
    const corePos = (t) => {
      const { core, ax, ay, A } = L;
      const k = easeIn3((t - ANVIL.sink) / (ANVIL.melt - ANVIL.sink));
      return { x: core.x + (ax + A * 0.04 - core.x) * k, y: core.y + (ay - A * 0.02 - core.y) * k, k };
    };
    // THE PULL: each card waits on the sheet trembling, then spirals into the core, swelling, burning white, swallowed
    const drawPull = (t, cp) => {
      const { A } = L;
      for (let i = 0; i < n; i++) {
        const at = anvilPullAt(i, n), p = (t - at) / ANVIL.pullDur;
        if (p >= 1) {
          if (!fired.has(`c${i}`)) {
            fired.add(`c${i}`); consumed++; coreKick = Math.min(1.6, coreKick + 0.5);
            sparks(cp.x, cp.y, lite ? 3 : 6, A * 0.9, Math.PI);
            if (haptics && i % 3 === 0) haptics.buzz(6);
          }
          continue;
        }
        const s0 = start[i];
        let x, y, w, rot = 0, heat = 0;
        const a = Math.min(1, t / 0.2);
        if (p < 0) {
          const tr = clamp01((t - ANVIL.pull + 0.4) / 0.8) * 2.5;      // the pull tugs at them before they go
          x = s0.x + Math.sin(t * 41 + i * 3) * tr; y = s0.y + Math.cos(t * 37 + i) * tr; w = s0.w;
        } else {
          const p2 = p * p, dir = i % 2 ? 1 : -1;
          const dx = s0.x - cp.x, dy = s0.y - cp.y, ang = p * 2.6 * dir, r = 1 - easeIn3(p) * 0.35 - p2 * 0.65;
          x = cp.x + (dx * Math.cos(ang) - dy * Math.sin(ang)) * r; y = cp.y + (dx * Math.sin(ang) + dy * Math.cos(ang)) * r;
          const wm = Math.max(s0.w, A * 0.17);
          w = p < 0.35 ? s0.w + (wm - s0.w) * easeOut3(p / 0.35) : wm + (A * 0.02 - wm) * easeIn3((p - 0.35) / 0.65);
          rot = p * 4.2 * dir; heat = clamp01((p - 0.25) / 0.6);
        }
        const h = w * 1.4;
        g.save();
        g.globalAlpha = a;
        g.translate(x, y); g.rotate(rot);
        if (heat > 0.3) { g.globalCompositeOperation = 'lighter'; glow(SP.warm, 0, 0, w * 1.3, heat * 0.8); g.globalCompositeOperation = 'source-over'; g.globalAlpha = a; }
        rr(g, -w / 2, -h / 2, w, h, Math.max(2, w * 0.07)); g.save(); g.clip(); drawCover(g, imgs[i], -w / 2, -h / 2, w, h);
        if (heat > 0) { g.globalAlpha = a * Math.min(1, heat * 1.2); g.drawImage(cardHeat, -w / 2, -h / 2, w, h); }
        g.restore();
        g.restore();
        if (heat > 0.4 && Math.random() < 0.3) embers(x, y, 1, w);
      }
    };
    // the converging energy lines of the pull (one batched path)
    const NLINES = 40;
    const drawPullLines = (t, cp, a) => {
      if (a <= 0.01 || reduced) return;
      const R0 = Math.hypot(W, H) * 0.62, m = lite ? NLINES / 2 : NLINES;
      g.globalCompositeOperation = 'lighter';
      g.strokeStyle = rgba([255, 214, 150], 1); g.lineCap = 'round';
      for (const [lw, al] of [[2.2, 0.22], [1, 0.55]]) {
        g.beginPath();
        for (let j = 0; j < m; j++) {
          const ang = j * 2.39996, q = (t * (0.9 + (j % 5) * 0.12) + j * 0.137) % 1;
          const r = L.A * 0.12 + R0 * Math.pow(1 - q, 1.6), len = L.A * (0.06 + 0.32 * (1 - q));
          const c = Math.cos(ang), sn = Math.sin(ang);
          g.moveTo(cp.x + c * r, cp.y + sn * r); g.lineTo(cp.x + c * (r + len), cp.y + sn * (r + len));
        }
        g.lineWidth = lw; g.globalAlpha = a * al; g.stroke();
      }
      g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
    };
    // the core: a white-hot heart in molten light, swelling as it eats; near the end it flares in the rank's colours
    const drawCore = (t, cp, fill, a) => {
      if (a <= 0.01) return;
      const { A } = L;
      const r = A * (0.05 + 0.13 * fill) * (1 + 0.18 * coreKick) * (1 - 0.55 * cp.k) * (0.94 + 0.06 * Math.sin(t * 19));
      g.globalCompositeOperation = 'lighter';
      glow(SP.warm, cp.x, cp.y, r * 5, 0.9 * a);
      const tell = reduced ? 0 : clamp01((t - (ANVIL.sink - 0.45)) / 0.35) * (1 - cp.k * 0.7);
      if (tell > 0) {          // v330 FLICKER: was a hard colour cut 7x a second (a strobe); now the rank's colours cross-fade
        tintGlow(t * 1.5, cp.x, cp.y, r * (3.2 + 1.2 * rank), tell * a);
        if (tints.length > 1) tintGlow(t * 1.5 + 1, cp.x, cp.y, r * 2.2, tell * 0.6 * a);
      }
      glow(SP.hot, cp.x, cp.y, r * 2.4, a);
      // two hot arcs swirling round it (the vortex)
      if (!reduced) {
        g.strokeStyle = 'rgba(255,236,190,1)'; g.lineWidth = Math.max(1.5, r * 0.08); g.lineCap = 'round';
        for (let k = 0; k < 2; k++) {
          const a0 = t * 7 + k * Math.PI;
          g.globalAlpha = 0.6 * a;
          g.beginPath(); g.ellipse(cp.x, cp.y, r * 1.5, r * 0.55, -0.25, a0, a0 + 1.6); g.stroke();
        }
      }
      g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
    };
    const drawRays = (t, cx, cy, a, R) => {
      if (a <= 0) return;
      const nR = lite ? Math.ceil(RK.rays * 0.6) : RK.rays;
      g.save();
      g.globalCompositeOperation = 'lighter';
      g.translate(cx, cy);
      const tt = Math.min(t, B() + RT.ready + 2.4);
      for (let k = 0; k < nR; k++) {
        const ang = tt * (0.12 + 0.03 * rank) + (k / nR) * Math.PI * 2 + Math.sin(k * 3.1) * 0.22;
        const wid = R * (0.07 + 0.05 * Math.abs(Math.sin(k * 1.7)));
        g.save(); g.rotate(ang);
        g.globalAlpha = a * (0.55 + 0.45 * Math.abs(Math.sin(k * 2.3 + tt * 0.8)));
        g.drawImage(shafts[k % shafts.length], 0, -wid / 2, R, wid);
        g.restore();
      }
      g.restore();
    };
    // heat shimmer: the air above the ingot wobbles (one snapshot of the region, then strips offset by a sine)
    const shimmer = (t, heat) => {
      if (lite || reduced || heat < 0.25) return;
      const { ax, ay, A } = L;
      const w = Math.round(A * 0.7), h = Math.round(A * 0.42), x = Math.round(ax + A * 0.04 - w / 2), y = Math.round(ay - h - 4);
      const sw = Math.round(w * dpr), sh = Math.round(h * dpr);
      if (shimmerCv.width !== sw || shimmerCv.height !== sh) { shimmerCv.width = sw; shimmerCv.height = sh; }
      const tr = g.getTransform();
      const sx0 = Math.round(x * dpr + tr.e), sy0 = Math.round(y * dpr + tr.f);
      if (sx0 < 0 || sy0 < 0 || sx0 + sw > cv.width || sy0 + sh > cv.height) return;
      shimmerG.clearRect(0, 0, sw, sh);
      shimmerG.drawImage(cv, sx0, sy0, sw, sh, 0, 0, sw, sh);
      const strip = 6, amp = 2.6 * heat;
      for (let yy = 0; yy < h; yy += strip) {
        const f = yy / h;
        const off = Math.sin(yy * 0.09 + t * 13) * amp * f + Math.sin(yy * 0.23 - t * 7) * amp * 0.4 * f;
        g.drawImage(shimmerCv, 0, yy * dpr, sw, strip * dpr, x + off, y + yy, w, strip);
      }
    };

    // the reveal's beats after the burst: ignite, the name slam, the type, Shao, Continue, the Duo lens
    const revealBeats = (u, cx = L.rcx, cy = L.rcy) => {
      if (!fired.has('ign') && u >= (reduced ? 0.3 : RT.ignite)) {
        fired.add('ign');
        cardEl.classList.add('ign');
        const v = cardEl.querySelector('video.ffv'); if (v) v.dataset.auto = '1';
        wireForgedVideos(cardEl);
        attachForgedFx(cardEl, card, { z: 75, boost: kind === 'fusion' ? 2.2 : 1.4 });
        forgedFxBurst(1.2 + 0.3 * rank);
        if (!reduced) {
          const r = Math.max(L.rw, L.rh) * L.gs;
          ring(cx, cy, r * (1.1 + 0.25 * rank), 0.7, 0.8, 1, 0);
          if (rank >= 2) ring(cx, cy, r * 1.7, 0.95, 0.6, 1, 1);
          for (let k = 0; k < RK.rc.length; k++) sparks(cx, cy, (24 + 22 * rank) / RK.rc.length, L.A * (2 + 0.5 * rank), Math.PI, 0, 4 + k, 2);
          if (haptics) haptics.buzz([14, 30, 22]);
        }
      }
      if (!fired.has('name') && u >= (reduced ? 0.5 : RT.name)) {
        fired.add('name');
        fitName();
        nameEl.classList.add('slam');
        if (!reduced) { shakeA = L.A * (0.018 + 0.006 * rank); shakeT = 0; punch = Math.max(punch, 0.02 + 0.006 * rank); if (haptics) haptics.buzz(30); }
      }
      if (!fired.has('text') && u >= (reduced ? 0.6 : RT.meta)) { fired.add('text'); kickEl.classList.add('on'); metaEl.classList.add('on'); }
      if (!fired.has('vo') && u >= (reduced ? 0.8 : RT.meta + 0.2)) { fired.add('vo'); if (vo) { try { vo(kind === 'duo' ? 'quip-forge-1' : 'quest-fusion-lesson'); } catch { /* optional */ } } }
      if (u >= (reduced ? 1.1 : RT.ready) && state.phase !== 'ready') { tapEl.classList.add('on'); state.phase = 'ready'; hintEl.classList.remove('on'); }
      if (kind === 'duo' && srcs && !state.lens && (state.idle || u >= RT.ready + 0.7)) {   // once the sparks settle the Duo shows what it does: A -> B -> A, then follows the tilt
        state.lens = true;
        const art = cardEl.querySelector('.art');
        state.sweep = duoLensSweep(art, srcs, { dur: 2400 });
        duoLensFollow(art, srcs, { when: () => !state.done });
      }
      if (u > RT.ready + 12) finish(true);                        // never strand the player
    };
    // ------------------------------------------------------------ the frame
    const frame = (now) => {
      if (state.done) return;
      try { frameBody(now); } catch (err) { console.warn('[forge] ceremony', err); finish(true); }
    };
    const SPK = [[255, 246, 214], [255, 200, 110], [255, 132, 44], [196, 56, 18], ...RK.rc];
    let zoomPrev = '', fin0 = false;
    const frameBody = (now) => {
      let rawDt = Math.min(0.05, (now - prevNow) / 1000); prevNow = now;
      // QA frame clock (frame captures): window.__nmForgeQa = { step: 1/60, paused: false }
      const qa = window.__nmForgeQa;
      if (qa) { rawDt = qa.paused ? 0 : (qa.step || 1 / 60); qaT += rawDt; }
      const t = qa ? qaT + tShift : (now - t0) / 1000 + tShift;
      state.t = t;
      // observed frame time: two slow seconds demote this run to lite
      if (!lite && !qa && t > 0.4) { frames++; slow = slow * 0.9 + (rawDt > 0.024 ? 1 : 0) * 0.1; if (frames > 30 && slow > 0.6) { lite = true; state.lite = true; layout(); } }
      if (failed) { state.phase = 'failed'; finish(false); return; }
      // the settled reveal: once the sparks are gone the canvas holds its last frame (rays frozen) — no redraw
      if (t >= B() + RT.ready + 1.2 && !parts.length && !rings.length && bloom < 0.01 && flash <= 0.01 && shakeA === 0 && punch < 0.001) {
        if (state.idle) { revealBeats(t - B()); requestAnimationFrame(frame); return; }
        state.idle = true;
      }
      // the gate: open once the server said yes (and the melt had its moment)
      if (G === null && resolved && t >= (reduced ? 0.7 : ANVIL.gate)) openGate(rush);
      else if (G === null && t >= ANVIL.gate) state.phase = 'wait';
      else if (G === null) state.phase = t < ANVIL.land ? 'intro' : t < ANVIL.sink ? 'pull' : 'melt';
      const frozen = inStop(t);
      const dt = frozen ? 0 : rawDt;
      const { ax, ay, A, fy } = L;
      const f = F(), b = B();
      // the build: 0 at the pull's start -> 1 at the gate, held through the blows, released by the final one
      const build = reduced ? 0 : t < f ? easeInOut((t - ANVIL.pull + 0.2) / (ANVIL.gate - ANVIL.pull + 0.2)) : 0;
      // camera: a push-in through the build, a punch on every blow, eased back for the reveal
      const dolly = reduced ? 0 : 0.06 * build * (1 - easeInOut((t - b) / 1.0));
      if (!frozen) punch *= Math.pow(0.0015, rawDt);
      const zoom = 1 + dolly + punch;
      const zs = zoom.toFixed(4);
      if (zs !== zoomPrev) { zoomPrev = zs; stageEl.style.transform = zoom === 1 ? '' : `scale(${zs})`; }
      // screen shake: decaying, ~22 Hz, plus the rumble of the build (grows with it)
      let sx = 0, sy = 0;
      if (shakeA > 0.4) {
        if (!frozen) shakeT += rawDt;
        const d = Math.exp(-shakeT * 7);
        sx = Math.sin(shakeT * 139) * shakeA * d; sy = Math.cos(shakeT * 113) * shakeA * d * 0.8;
        if (d < 0.03) shakeA = 0;
      }
      if (build > 0 && !frozen && t < f) {
        const rum = A * (0.0025 + 0.0012 * rank) * build * build;
        sx += (Math.sin(t * 37) + Math.sin(t * 66) * 0.6) * rum; sy += (Math.cos(t * 45) + Math.sin(t * 79) * 0.5) * rum;   // v330: half the rate (12-25 Hz aliased into shimmer)
      }
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
      g.save(); g.translate(sx, sy);
      // the forge in the dark: fades up from black
      const amb = reduced ? 1 : Math.min(1, t / 0.5);
      const rm = ART.room;
      g.fillStyle = '#030202'; g.fillRect(-40, -40, W + 80, H + 80);
      g.globalAlpha = amb; blit(rm.c, -rm.pad, -rm.pad, W + rm.pad * 2, H + rm.pad * 2); g.globalAlpha = 1;
      const dissolve = clamp01((t - f) / 0.5);
      const heat = reduced ? clamp01(t / 0.6) : clamp01((t - ANVIL.melt + 0.15) / 0.5);
      const flick = 0.9 + 0.06 * Math.sin(t * 7.3) + 0.04 * Math.sin(t * 17.1);
      // the hearth breathes brighter as the metal heats (and on every blow)
      g.globalCompositeOperation = 'lighter';
      glow(SP.warm, ax, ay - A * 0.05, A * 1.5, ((0.22 + 0.5 * heat) * flick + 0.6 * bloom) * amb * (1 - 0.6 * dissolve));
      g.globalCompositeOperation = 'source-over';
      // the forge closes in: the room falls into black around the core as the build rises (and stays dark for the reveal)
      const cp = corePos(t);
      const vig = reduced ? 0 : t < f ? 0.92 * build : 0.55 + 0.37 * (1 - clamp01((t - f) / 0.75));
      if (vig > 0.01) {
        const vx = t < f ? cp.x : W / 2, vy = t < f ? (cp.y + ay) / 2 : H / 2;
        const vr = Math.hypot(W, H) * (1.25 - 0.55 * (t < f ? build : 0.4));
        g.globalAlpha = vig; g.drawImage(VIG, vx - vr, vy - vr, vr * 2, vr * 2);
        g.fillStyle = '#010000';
        if (vx - vr > -40) g.fillRect(-40, -40, vx - vr + 40, H + 80);
        if (vx + vr < W + 40) g.fillRect(vx + vr, -40, W + 40 - vx - vr, H + 80);
        if (vy - vr > -40) g.fillRect(-40, -40, W + 80, vy - vr + 40);
        if (vy + vr < H + 40) g.fillRect(-40, vy + vr, W + 80, H + 40 - vy - vr);
        g.globalAlpha = 1;
      }

      // ---- anvil: slams down (ease-in) at ANVIL.land; sinks into the light after the final blow
      let anvY = ay, anvA = 0;
      if (reduced) { anvA = Math.min(1, t / 0.5) * (1 - dissolve); }
      else if (t >= ANVIL.drop) {
        const p = clamp01((t - ANVIL.drop) / (ANVIL.land - ANVIL.drop));
        anvY = ay - (1 - easeIn3(p)) * (ay + A * 0.7);
        anvA = (1 - dissolve);
        g.globalAlpha = (0.3 + 0.6 * easeIn3(p)) * anvA;
        g.drawImage(SP.shadow, ax - A * 0.55, fy - A * 0.05, A * 1.1, A * 0.1);
        g.globalAlpha = 1;
      }
      drawAnvil(anvY, anvA, heat * 0.85 * flick + bloom * 0.6 + 0.25 * build);
      if (!reduced && !fired.has('land') && t >= ANVIL.land) {
        fired.add('land');
        shakeA = A * 0.045; shakeT = 0; punch = 0.03;
        sparks(ax - A * 0.36, fy, 18, A * 1.0, 0.45, Math.PI + 0.25);
        sparks(ax + A * 0.36, fy, 18, A * 1.0, 0.45, -0.25);
        smoke(ax - A * 0.3, fy - A * 0.02, 6, { vx: A * 0.4, spread: 0.3, vy: -14, size: 0.24, a: 0.55 });
        smoke(ax + A * 0.3, fy - A * 0.02, 6, { vx: A * 0.4, spread: 0.3, vy: -14, size: 0.24, a: 0.55 });
        ring(ax, fy, A * 1.6, 0.6, 0.35, 0.2);
        if (haptics) haptics.buzz(24);
      }
      // ---- THE PULL: lines converge, cards spiral into the core, the core swells; the count ticks up
      const fill = n ? consumed / n : 1;
      const coreA = reduced ? 0 : clamp01((t - ANVIL.pull + 0.15) / 0.3) * (1 - clamp01((t - ANVIL.melt) / 0.15));
      if (!reduced && t < ANVIL.melt + 0.2) {
        drawPullLines(t, cp, coreA * (1 - cp.k) * (0.35 + 0.65 * build));
        drawCore(t, cp, fill, coreA);
        drawPull(t, cp);
        if (coreA > 0.3 && Math.random() < (lite ? 0.25 : 0.6)) embers(cp.x, cp.y, 1, A * 0.12);
      }
      if (!frozen) coreKick *= Math.pow(0.02, rawDt);
      if (nAll > 1 && !reduced) {      // the count of cards being spent, ticking up over the core as they are swallowed
        const on = consumed > 0 && t < ANVIL.sink + 0.1;
        if (on) {
          const txt = `×${Math.round(fill * nAll)}`;
          if (countEl.textContent !== txt) countEl.textContent = txt;
          countEl.style.transform = `translate(${(L.core.x + sx).toFixed(0)}px,${(L.core.y - A * 0.26 + sy).toFixed(0)}px) translate(-50%,-100%)`;
        }
        if (on !== countEl.classList.contains('on')) countEl.classList.toggle('on', on);
      }
      let squash = 1;
      for (let i = skipTo; i <= last; i++) if (t >= strikeAt(i)) squash += 0.22;
      drawIngot(t, heat * (1 - dissolve), squash);
      if (heat > 0 && t < f && Math.random() < (lite ? 0.3 : 0.7)) embers(ax + A * 0.04, ay - 6, 1, A * 0.3);
      if (heat > 0.4 && t < f && !reduced && Math.random() < 0.05) smoke(ax + A * 0.04, ay - A * 0.04, 1, { vy: -40, size: 0.16, a: 0.4 });
      // ---- the hammer: swings down into frame before the gate, strikes, vanishes in the white
      if (!reduced) {
        const pin = clamp01((t - ANVIL.sink) / 0.5);         // it swings in as the core sinks (never across the pull)
        if (pin > 0) {
          const hp = hammerPose(t);
          const near = clamp01(1 - (hp.th - L.thI) / 0.5);
          drawHammer(hp.th + (1 - easeOut3(pin)) * 1.1, 1 - dissolve, hp.smear, heat * (0.25 + 0.75 * near) + bloom * 0.8);
        }
      }
      // ---- the blows: each one bigger; the last whites out the world
      for (let i = skipTo; i <= last; i++) {
        if (fired.has(`s${i}`) || t < strikeAt(i)) continue;
        fired.add(`s${i}`);
        state.strikes++;
        const fin = i === last, k = (i + 1) / S.length;
        const hx = ax + A * 0.04, hy = ay - 4;
        if (reduced) { bloom = 0.6; continue; }
        flash = fin ? 0.9 : 0.12 + 0.1 * k;
        bloom = 1; streak = fin ? 1 : 0.5 + 0.3 * k;
        shakeA = A * (fin ? 0.09 + 0.02 * rank : 0.026 + 0.024 * k); shakeT = 0;
        punch = fin ? 0.11 + 0.015 * rank : 0.022 + 0.02 * k;
        const nS = fin ? 260 + 70 * rank : 70 + 50 * i;
        sparks(hx - A * 0.06, hy, nS * 0.45, A * (fin ? 3.4 : 2.4), 0.7, -Math.PI * 0.88);
        sparks(hx + A * 0.06, hy, nS * 0.45, A * (fin ? 3.4 : 2.4), 0.7, -Math.PI * 0.12);
        droplets(hx, hy, fin ? 30 + 10 * rank : 6 + 5 * i, A * (fin ? 2.2 : 1.5));
        smoke(hx, hy - A * 0.03, fin ? 10 : 2 + i, { vy: -50, size: fin ? 0.32 : 0.2, a: fin ? 0.55 : 0.32, spread: fin ? 0.5 : 0.2 });
        ring(hx, hy, A * (fin ? 1.6 : 0.7 + 0.35 * k), fin ? 0.5 : 0.4, fin ? 1 : 0.55);
        if (fin) {
          whiteAt = t;
          ring(hx, hy, Math.hypot(W, H) * 1.05, 0.95, 0.9);
          ring(hx, fy, A * (3 + 0.5 * rank), 1.1, 0.7, 0.18);
          if (rank >= 1) ring(hx, hy, Math.hypot(W, H) * 0.8, 1.2, 0.7, 1, 0);
          sparks(hx, hy - A * 0.06, 120 + 50 * rank, A * 4, Math.PI, 0);
          embers(W / 2, H + 10, 60 + 20 * rank, W);
          smoke(ax, fy, 8, { vx: A * 0.5, spread: 0.6, vy: -18, size: 0.3, a: 0.6 });
        } else embers(hx, hy, 12, A * 0.3);
        if (haptics) haptics.buzz(fin ? [60, 30, 120] : [18 + 10 * i]);
        if (fin) { state.phase = 'reveal'; fin0 = true; }
      }
      // ---- the reveal: the card spins out of the light, white-hot, cools, faces the player, settles
      const cx0 = ax + A * 0.04;
      let cardX = W / 2, cardY = H / 2;
      if (t >= b) {
        const u = t - b;
        let x, y, s, ry = 0, rx = 0, op = 1;
        if (reduced) { x = L.rcx; y = L.rcy; s = 1; op = clamp01(u / 0.5); }
        else {
          const gx = W / 2, gy = H * (L.portrait ? 0.47 : 0.5);
          const pE = clamp01((u - RT.emerge) / (RT.faced - RT.emerge));
          const pS = easeInOut((u - RT.settle) / RT.settleDur);
          if (u < RT.settle) {
            const pm1 = easeOutExpo(pE), pr = easeOut3(pE);
            x = cx0 + (gx - cx0) * pm1; y = ay - A * 0.1 + (gy - ay + A * 0.1) * pm1;
            s = 0.15 + (L.gs * (1 + 0.025 * clamp01((u - RT.faced) / 0.4)) - 0.15) * pr;
            ry = -RK.spin * (1 - pr); rx = (1 - pr) * 22;
          } else { const sg = L.gs * 1.025; x = gx + (L.rcx - gx) * pS; y = gy + (L.rcy - gy) * pS; s = sg + (1 - sg) * pS; }
          op = clamp01((u - RT.emerge) / 0.06);
        }
        cardX = x; cardY = y;
        cardEl.style.opacity = String(op);
        const back = Math.cos((ry * Math.PI) / 180) * Math.cos((rx * Math.PI) / 180) < 0;
        if (back !== cardEl.classList.contains('bk')) cardEl.classList.toggle('bk', back);
        cardEl.style.transform = `translate(${(x + sx - L.rw / 2).toFixed(1)}px,${(y + sy - L.rh / 2).toFixed(1)}px) perspective(1600px) rotateX(${rx.toFixed(1)}deg) rotateY(${ry.toFixed(1)}deg) scale(${s.toFixed(4)})`;
        hotEl.style.opacity = reduced ? '0' : String(1 - easeOut3((u - RT.emerge - 0.25) / (RT.faced - RT.emerge)));
        if (!reduced && !fired.has('emerge') && u >= RT.emerge) {
          fired.add('emerge');
          embers(cx0, ay, 40 + 15 * rank, A * 0.5);
          if (rank >= 1) for (let k = 0; k < RK.rc.length; k++) sparks(cx0, ay - A * 0.1, (30 + 30 * rank) / RK.rc.length, A * 3, Math.PI, -Math.PI / 2, 4 + k, 2);
        }
        // light behind the card: a glow in the rank's colours + slow shafts (on the canvas, under the DOM card)
        const ra = reduced ? 0.4 * clamp01(u / 0.5) : clamp01((u - RT.emerge * 0.5) / 0.25) * (u < RT.settle ? 1 : 1 - 0.4 * clamp01((u - RT.settle) / 0.8));
        g.globalCompositeOperation = 'lighter';
        glow(SP.warm, x, y, Math.max(L.rw, L.rh) * s * 0.9, ra * 0.8);
        tintGlow(t * 0.8, x, y, Math.max(L.rw, L.rh) * s * (0.8 + 0.12 * rank), ra * (0.35 + 0.12 * rank));   // v330: was a hard colour swap every .5 s
        g.globalCompositeOperation = 'source-over';
        drawRays(t, x, y, ra * 0.9, Math.max(W, H) * 0.9);
        revealBeats(u, x, y);
      }
      // ---- smoke (lit haze, normal blend) under the light
      for (let i = parts.length - 1; i >= 0; i--) {
        const q = parts[i];
        if (q.k !== 3) continue;
        q.life -= dt;
        if (q.life <= 0) { parts[i] = parts[parts.length - 1]; parts.pop(); continue; }
        const lf = q.life / q.max;
        q.x += q.vx * dt; q.y += q.vy * dt; q.vx *= Math.pow(0.4, dt); q.s += dt * L.A * 0.12;
        g.globalAlpha = q.a * Math.min(1, (1 - lf) * 5) * lf;
        g.drawImage(SP.smoke, q.x - q.s, q.y - q.s, q.s * 2, q.s * 2);
      }
      g.globalAlpha = 1;
      // ---- light: the strike's bloom + a horizontal lens streak, the shockwave rings, then sparks, droplets, embers (all additive)
      g.globalCompositeOperation = 'lighter';
      if (bloom > 0.01) {
        glow(SP.hot, cx0, ay - 4, A * (0.45 + 1.1 * bloom), 0.85 * bloom);
        glow(SP.warm, cx0, ay, A * (1 + 1.4 * bloom), 0.6 * bloom);
        bloom *= Math.pow(0.06, dt);
      }
      if (streak > 0.01) {
        g.globalAlpha = Math.min(1, streak * 0.8);
        g.drawImage(SP.hot, cx0 - W * 0.75 * (0.6 + streak * 0.4), ay - 4 - A * 0.025, W * 1.5 * (0.6 + streak * 0.4), A * 0.05);
        streak *= Math.pow(0.03, dt);
      }
      for (let i = rings.length - 1; i >= 0; i--) {
        const q = rings[i];
        q.age += dt;
        const p = q.age / q.dur;
        if (p >= 1) { rings[i] = rings[rings.length - 1]; rings.pop(); continue; }
        const r = q.r1 * easeOut3(p) + 2;
        g.globalAlpha = Math.min(1, q.a * (1 - p) * (1 - p) * 1.3);
        g.drawImage(RING, q.x - r, q.y - r * q.flat, r * 2, r * 2 * q.flat);
        if (q.tint >= 0) { g.globalAlpha *= 0.8; g.drawImage(tints[q.tint % tints.length], q.x - r * 0.98, q.y - r * 0.98 * q.flat, r * 1.96, r * 1.96 * q.flat); }
      }
      g.globalAlpha = 1;
      const bk = new Map();
      const bucket = (kind, ci, a, w) => {
        const q4 = Math.max(1, Math.round(a * 4)), key = `${kind}|${ci}|${q4}|${w}`;
        let bb = bk.get(key);
        if (!bb) { bb = { kind, c: SPK[ci], a: q4 / 4, w, pts: [] }; bk.set(key, bb); }
        return bb.pts;
      };
      const grav = A * 2.4;
      for (let i = parts.length - 1; i >= 0; i--) {
        const q = parts[i];
        if (q.k === 3) continue;
        q.life -= dt;
        if (q.life <= 0) { parts[i] = parts[parts.length - 1]; parts.pop(); continue; }
        const lf = q.life / q.max;
        const a = Math.min(1, lf * 2.2);
        if (q.k === 0) {           // spark: arcs with gravity, bounces off the floor, cools white -> gold -> orange -> red (or keeps its rank colour)
          q.vx *= Math.pow(0.55, dt); q.vy = q.vy * Math.pow(0.55, dt) + grav * dt;
          q.x += q.vx * dt; q.y += q.vy * dt;
          if (q.y > fy && q.vy > 0 && q.b < 2) { q.y = fy; q.vy *= -0.3; q.vx *= 0.7; q.b++; }
          const sp = Math.hypot(q.vx, q.vy) + 1e-3, sl = Math.min(frozen ? 0.012 : 0.026, (A * 0.045) / sp);   // short streaks: sparks, not speed lines
          const ci = q.c >= 0 && q.c < SPK.length ? q.c : lf > 0.72 ? 0 : lf > 0.45 ? 1 : lf > 0.2 ? 2 : 3;
          bucket(0, ci, a, q.s).push(q.x - q.vx * sl, q.y - q.vy * sl, q.x + 0.01, q.y);
        } else if (q.k === 1) {    // ember: floats up, sways, flickers out
          q.ph += dt * 3; q.x += (q.vx + Math.sin(q.ph) * 30) * dt; q.y += q.vy * dt; q.vy *= Math.pow(0.7, dt);
          bucket(1, lf > 0.5 ? 2 : 3, a * (0.75 + 0.25 * Math.sin(q.ph * 4)), 0).push(q.x, q.y, q.s);
        } else {                   // molten droplet: a heavy glowing blob, one splash on the floor then it cools there
          if (q.b === 0) {
            q.vy += grav * dt; q.x += q.vx * dt; q.y += q.vy * dt;
            if (q.y > fy && q.vy > 0) { q.y = fy; q.b = 1; q.vx *= 0.15; q.vy = 0; sparks(q.x, fy, 3, A * 0.5, 0.9, -Math.PI / 2); }
          } else q.x += q.vx * dt;
          const r = q.s * (q.b ? 1.4 : 1);
          glow(SP.hot, q.x, q.y, r * 3.2, a * (q.b ? 0.55 : 0.9));
        }
      }
      g.globalAlpha = 1;
      for (const bb of bk.values()) {
        const p = bb.pts;
        g.beginPath();
        if (bb.kind === 0) {
          for (let k = 0; k < p.length; k += 4) { g.moveTo(p[k], p[k + 1]); g.lineTo(p[k + 2], p[k + 3]); }
          g.strokeStyle = rgba(bb.c, bb.a); g.lineWidth = bb.w; g.lineCap = 'round'; g.stroke();
        } else {
          for (let k = 0; k < p.length; k += 3) { g.moveTo(p[k] + p[k + 2], p[k + 1]); g.arc(p[k], p[k + 1], p[k + 2], 0, Math.PI * 2); }
          g.fillStyle = rgba(bb.c, bb.a); g.fill();
        }
      }
      g.globalCompositeOperation = 'source-over';
      if (t < f + 0.3) shimmer(t, heat * (1 - dissolve));
      g.restore();
      // the flash of each blow: a burst of light from the anvil (additive, so the dark stays dark at the edges)
      if (flash > 0.01) {
        g.globalCompositeOperation = 'lighter';
        glow(SP.hot, ax + A * 0.04, ay, Math.max(W, H) * 1.1, Math.min(1, flash * 1.3));
        g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
        flash *= Math.pow(fin0 ? 0.004 : 0.002, rawDt);
      }
      // THE WHITE-OUT: the final blow blinds the screen (held longer by rank), then the light drains to reveal the card
      if (whiteAt >= 0) {
        const w = t - whiteAt;
        const peak = rank === 0 ? 0.9 : 1;
        const wa = w < RT.white ? peak : peak * Math.exp(-(w - RT.white) * 4.2);
        if (wa > 0.004) { g.fillStyle = `rgba(255,251,242,${wa.toFixed(3)})`; g.fillRect(0, 0, W, H); }
        else whiteAt = -1;
      }
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
    state.skip = () => finish(true);
  });
}
